Service = App.loadClass 'core::Angular/Service'

class exports.SetupService extends Service

    constructor: (@http, @rootScope, @factory) ->
        null

    # Seed Companies

    getSeedCompanies: (lineups_id) =>
        params =
            lineups_id: lineups_id

        return @http.post('backend/portal/ratings/seed-companies/load', params).then((response) -> response.data).then (response) =>
            if response.status?.type is 'success'
                for props, i in response.data.seed_companies
                    obj = @factory.make('SeedCompany', props)
                    response.data.seed_companies[i] = obj
            return response

    # Trait Packages

    getTraitPackages: (lineups_id) =>
        params =
            lineups_id: lineups_id

        return @http.post('backend/portal/ratings/trait-packages/load', params).then((response) -> response.data).then (response) =>
            if response.status?.type is 'success'
                for props, i in response.data.trait_packages
                    obj = @factory.make('TraitPackage', props)
                    response.data.trait_packages[i] = obj
            return response

    getTraitSuppliers: () =>
        params = {}

        return @http.post('backend/portal/ratings/trait-packages/load-trait-suppliers', params).then((response) -> response.data).then (response) =>
            if response.status?.type is 'success'
                for props, i in response.data.trait_suppliers
                    obj = @factory.make('TraitSupplier', props)
                    response.data.trait_suppliers[i] = obj
            return response

    saveTraitPackage: (lineups_id, trait_package) =>
        params =
            lineups_id: lineups_id
            id: trait_package.id
            name: trait_package.name
            suffix: trait_package.suffix
            description: trait_package.description
            trait_suppliers_id: trait_package.trait_suppliers_id

        return @http.post('backend/portal/ratings/trait-packages/save', params).then((response) -> response.data).then (response) =>
            if response.status?.type is 'success'
                obj = @factory.make('TraitPackage', response.data)
                response.data = obj
            return response

    deleteTraitPackage: (lineups_id, trait_package) =>
        params =
            lineups_id: lineups_id
            id: trait_package.id
        return @http.post('backend/portal/ratings/trait-packages/delete', params).then((response) -> response.data)


    # Treatments

    getTreatments: (lineups_id) =>
        params =
            lineups_id: lineups_id

        return @http.post('backend/portal/ratings/treatments/load', params).then((response) -> response.data).then (response) =>
            if response.status?.type is 'success'
                for props, i in response.data.treatments
                    obj = @factory.make('Treatment', props)
                    response.data.treatments[i] = obj
            return response

    saveTreatment: (lineups_id, treatment) =>
        params =
            lineups_id: lineups_id
            id: treatment.id
            name: treatment.name
            treatment_code: treatment.treatment_code
            description: treatment.description

        return @http.post('backend/portal/ratings/treatments/save', params).then((response) -> response.data).then (response) =>
            if response.status?.type is 'success'
                obj = @factory.make('Treatment', response.data)
                response.data = obj
            return response

    deleteTreatment: (lineups_id, treatment) =>
        params =
            lineups_id: lineups_id
            id: treatment.id

        return @http.post('backend/portal/ratings/treatments/delete', params).then((response) -> response.data)


    # Products

    getProducts: (lineups_id) =>
        params =
            lineups_id: lineups_id

        return @http.post('backend/portal/ratings/products/load', params).then((response) -> response.data).then (response) =>
            if response.status?.type is 'success'
                for props, i in response.data.products
                    obj = @factory.make('Product', props)
                    response.data.products[i] = obj
            return response

    createProducts: (lineups_id, products) =>
        params =
            lineups_id: lineups_id
            products: []

        for product in products
            params.products.push
                seed_companies_id: product.seed_companies_id
                name: product.name
                trait_packages_id: product.trait_packages_id

        return @http.post('backend/portal/ratings/products/create', params).then((response) -> response.data).then (response) =>
            if response.status?.type is 'success'
                for product, i in response.data
                    obj = @factory.make('Product', product)
                    response.data[i] = obj
            return response

    updateProduct: (lineups_id, product) =>
        params =
            lineups_id: lineups_id
            id: product.id
            seed_companies_id: product.seed_companies_id
            name: product.name
            trait_packages_id: product.trait_packages_id

        return @http.post('backend/portal/ratings/products/update', params).then((response) -> response.data).then (response) =>
            if response.status?.type is 'success'
                obj = @factory.make('Product', response.data)
                response.data = obj
            return response

    activateProduct: (lineups_id, product) =>
        params =
            lineups_id: lineups_id
            id: product.id

        return @http.post('backend/portal/ratings/products/activate', params).then((response) -> response.data).then (response) =>
            if response.status?.type is 'success'
                # format the seed company or trait package if they were
                # automatically activated as a result
                if response.data.seed_company?
                    obj = @factory.make('SeedCompany', response.data.seed_company)
                    response.data.seed_company = obj
                if response.data.trait_package?
                    obj = @factory.make('TraitPackage', response.data.trait_package)
                    response.data.trait_package = obj
            return response

    deactivateProduct: (lineups_id, product) =>
        params =
            lineups_id: lineups_id
            id: product.id

        return @http.post('backend/portal/ratings/products/deactivate', params).then((response) -> response.data)
